import { VueRegistration } from '@abaco/web-common/src/app';
const CONTEXT = "SOUTHERN_WATERS";

const globals: VueRegistration = {
    "SouthernWatersBarChart": {
        meta: {
            i18nDescrKey: "south-waters-bar-chart-widget",
            tag: CONTEXT,
            pinnable: true,
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"]
        },
        component: () => import("./components/SouthernWatersBarChart.vue")
    },
    "SouthernWatersDataList": {
        meta: {
            i18nDescrKey: "south-waters-data-list-widget",
            tag: CONTEXT,
            pinnable: true
        },
        component: () => import("./components/SouthernWatersDataList.vue")
    },
    "SouthernWatersGaugeChart": {
        meta: {
            i18nDescrKey: "south-waters-gauge-chart-widget",
            tag: CONTEXT,
            pinnable: true,
            filters: ["farm-select-nav-bar-item", 'campaign-select-nav-bar-item', "plot-selection-nav-bar-item"]
        },
        component: () => import("./components/SouthernWatersGaugeChart.vue")
    },
    "SouthernWatersMapTile": {
        meta: {
            i18nDescrKey: "south-waters-map-label",
            tag: CONTEXT,
            pinnable: true,
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"]
        },
        component: () => import("./components/SouthernWatersMapTile.vue")
    },
};


export default globals;
